import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GoBackLinkKeyType } from "../components/hook/useCurrentGoBackLink";
import { navigationLinks } from "../navigation/Navigation";

export type NavigationState = {
    goBackLinks: Record<GoBackLinkKeyType, string>;
};

const initialState: NavigationState = {
    goBackLinks: {
        contacts: navigationLinks.TAX_CONTACTS_LINK,
    },
};

export const navigationSlice = createSlice({
    name: "navigation",
    initialState,
    reducers: {
        setGoBackLink: (state, action: PayloadAction<{ link: string; key: GoBackLinkKeyType }>) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            const payload = action.payload;
            state.goBackLinks[payload.key] = payload.link;
        },
    },
});

// Action creators are generated for each case reducer function
export const {setGoBackLink} = navigationSlice.actions;

export default navigationSlice.reducer;
